'use client'

import { onForegroundMessage } from '@/core/firebase'
import { NotificationModel } from '@/core/types/models/notification.model'
import { addToast } from '@heroui/toast'
import { useEffect } from 'react'
import { usePushNotificationsStore } from '../store'
import { NotificationMessage } from '../ui'

const playNotificationSound = () => {
  const audio = new Audio('/audio/notification.wav')
  audio.play()
}

type Params = {
  onNotification?: (notification: NotificationModel) => void
}

export const useObserveNotifications = ({ onNotification }: Params = {}) => {
  const { observers, guards } = usePushNotificationsStore()

  useEffect(() => {
    let unsub: (() => void) | null = null
    const init = async () => {
      const { unsubscribe } = await onForegroundMessage(notification => {
        const canActivate = guards.every(g => g.canActivate(notification))
        if (!canActivate) return

        playNotificationSound()
        onNotification?.(notification)

        addToast({
          title: (
            <NotificationMessage
              title={notification.notification?.title || 'New notification'}
              body={notification.notification?.body}
            />
          ),
          color: 'default',
        })

        observers.forEach(o => o.update(notification))
      })

      unsub = unsubscribe
    }

    init()

    return () => {
      if (unsub) unsub()
    }
  }, [guards, observers, onNotification])
}
